import React, { useState, useEffect, useMemo } from "react";
import * as S from "./PatientBarriersModal.style";
import * as P from "../../../../../../../../../utils/pipes";
import ZaiaReaction from "../../../../../../../../zaiaComponents/zaiaReaction";
import { useTranslation } from "react-i18next";
import BarrierDetails from "./components/barrierDetails/BarrierDetails";
import FlorenzButton from "../../../../../../../../florenzComponents/florenzButton";
import FlorenzSelect from "../../../../../../../../florenzComponents/florenzSelect";
import FlorenzSearchInput from "../../../../../../../../florenzComponents/florenceSearchInput";
import { useQuery } from "@apollo/client";
import { QUERY_GET_BARRIER_TYPES, QUERY_GET_USER_TO_BARRIERS_FILTERS, QUERY_GET_BARRIER_BY_ID } from "../../../../../../../../../graphql/mutations/Barriers";
import { QUERY_GET_USER_TO_PROCESS_BY_ISACEPTED } from "../../../../../../../../../graphql/queries/UserToProcess";

// Assets
const logoZaiaLoading = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/singularity-health-loader.svg`;
const logoZaiaAlert = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/reaction-error-data.svg`;

const ENV = process.env.REACT_APP_ENV;

const PatientBarriersModal = ({ patient, onClose, barrierId, onOpenNewBarrier }) => {
  const [showResolved, setShowResolved] = useState(false);
  const [selectedBarrier, setSelectedBarrier] = useState(null);
  const {t, i18n: { language }} = useTranslation("global");
  const [inputText, setInputText] = useState("");
  const [selectedBarrierType, setSelectedBarrierType] = useState(null);
  const [isFetchingMore, setIsFetchingMore] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [offset, setOffset] = useState(0);
  const [barriersList, setBarriersList] = useState([]);

  const loadLimit = 20; 

  const { data: patientData, loading: patientLoading } = useQuery(QUERY_GET_USER_TO_PROCESS_BY_ISACEPTED, {
    variables: {
      where: { id: { _eq: patient?.id } },
      limit: 1,
      offset: 0
    },
    skip: !patient?.id || !!patient?.user
  });

  const activePatient = patient?.user ? patient : patientData?.userToProcess?.[0];
  const processId = activePatient?.process?.id || activePatient?.processId;

  const { data: barrierTypes } = useQuery(QUERY_GET_BARRIER_TYPES, {
    variables: {
      processId: processId
    },
    skip: !processId
  });

  const where = {
    userToProcessId: { _eq: patient?.id }
  };

  if (inputText && inputText.trim() !== "") {
    const terms = inputText.trim().split(/\s+/);

    where._and = terms.map(term => ({
      _or: [
        { name: { _ilike: `%${term}%` } },
        { description: { _ilike: `%${term}%` } },
      ]
    }));
  }

  if (selectedBarrierType !== null && selectedBarrierType !== undefined) {
    where.barrierTypeId = { _eq: selectedBarrierType };
  }

  if(!showResolved) {
    where.barrierStatus = { _eq: "pending" }
  }

  const { data: userToBarriers, loading: userToBarriersLoading, error: userToBarriersError, fetchMore } = useQuery(
    QUERY_GET_USER_TO_BARRIERS_FILTERS, 
    { 
      variables: { 
        where,
        limit: loadLimit, 
        offset: 0
      },
      fetchPolicy: "network-only",
      notifyOnNetworkStatusChange: true
    },
  ); 

  console.log("weeelcome", userToBarriersError);
  
  console.log("aasdfasdfasdf", userToBarriers);
  

  const mockBarriers = [
    {
      id: 1,
      type: "Barrera Psicológica, Miedo-Cancerofóbia",
      desc: "La paciente tiene miedo de ir a recoger sus exámenes...",
      date: "3 Enero 2025",
      phase: 4
    },
    {
      id: 2,
      type: "Barrera Psicológica, Miedo-Cancerofóbia",
      desc: "La paciente tiene miedo de ir a recoger sus exámenes...",
      date: "3 Enero 2025",
      phase: 4
    },
    {
      id: 3,
      type: "Barrera Psicológica, Miedo-Cancerofóbia",
      desc: "La paciente tiene miedo de ir a recoger sus exámenes...",
      date: "3 Enero 2025",
      phase: 4
    },
    {
      id: 4,
      type: "Barrera Psicológica, Miedo-Cancerofóbia",
      desc: "La paciente tiene miedo de ir a recoger sus exámenes...",
      date: "3 Enero 2025",
      phase: 4
    }
  ];

  console.log('barrierTypes', barrierTypes);  


  const { data: singleBarrierData, loading: singleBarrierLoading } = useQuery(QUERY_GET_BARRIER_BY_ID, {
    variables: { _eq: barrierId },
    skip: !barrierId
  });

  useEffect(() => {
    if (barrierId && singleBarrierData?.userToBarrier?.length > 0) {
      setSelectedBarrier(singleBarrierData.userToBarrier[0]);
    } else if (!barrierId) {
      setSelectedBarrier(null);
    }
  }, [barrierId, singleBarrierData]);


  useEffect(() => {
    if (userToBarriersLoading) return;
    if (userToBarriers?.userToBarrier) {
      setBarriersList(userToBarriers.userToBarrier);
      setOffset(userToBarriers.userToBarrier.length);
      
      if (userToBarriers.userToBarrier.length <= loadLimit) {
        setHasMore(userToBarriers.userToBarrier.length === loadLimit);
      }
    }
  }, [userToBarriersLoading, userToBarriers]);

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    if (scrollHeight - scrollTop <= clientHeight + 100 && hasMore && !userToBarriersLoading && !isFetchingMore) {
      setIsFetchingMore(true);
      fetchMore({
        variables: {
          limit: loadLimit,
          offset: offset,
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult || fetchMoreResult.userToProcess.length === 0) {
            return prev;
          }

          const existingIds = new Set(prev.userToProcess.map(p => p.id));
          const newItems = fetchMoreResult.userToProcess.filter(p => !existingIds.has(p.id));

          return {
            ...prev,
            userToProcess: [...prev.userToProcess, ...newItems]
          };
        }
      }).then(({ data }) => {
        if (!data || !data.userToProcess || data.userToProcess.length < loadLimit) {
          setHasMore(false);
        }
        setIsFetchingMore(false);
      }).catch(() => {
        setIsFetchingMore(false);
      });
    }
  };

  if (!patient) return null;

  if (patientLoading && !activePatient) {
    return (
      <S.PatientBarriersModal>
        <div className="modal-background" onClick={() => onClose()} />
        <div className="modal-container">
          <div className="modal-container__reaction" style={{ display: 'flex', justifyContent: 'center' }}>
            <ZaiaReaction widthimg="150px" zaiaImg={logoZaiaLoading} /> 
          </div>
        </div>
      </S.PatientBarriersModal>
    );
  }

  if(false) 
    return (
      <S.PatientBarriersModal>
        <div className="modal-background" onClick={() => onClose()}>
        </div>
        <div className="modal-container">
          <div className="modal-container__reaction">
            <ZaiaReaction
              widthimg="150px"
              zaiaImg={logoZaiaLoading}
            /> 
          </div>
        </div>
      </S.PatientBarriersModal>
    )
    
    if(false) 
      return (
        <S.PatientBarriersModal>
          <div className="modal-background" onClick={() => onClose()}>
          </div>
          <div className="modal-container">
            <div className="modal-container__reaction">
              <ZaiaReaction
                zaiaImg={logoZaiaAlert}
                widthimg="200px"
                text={t("globally.genericError")}
                sizeText="18px"
                widthText="290px"
              />
            </div>
          </div>
        </S.PatientBarriersModal>
      )     

console.log(activePatient, "activePatient");


  return (
    <S.PatientBarriersModal>
      <div className="modal-background" onClick={() => onClose()}>
      </div>
      <div className="modal-container">
        <S.Header>
          <div className="close-btn" onClick={onClose}>
            <i className="icon zaia-icono-cerrar"></i>
          </div>
          <div className="title">Barreras de Journey de paciente</div>
        </S.Header>

        <S.Body>
          <div className="body-top">
            <S.LeftPanel>
              <div className="patient-card">
                <div className="patient-header">
                  <img src={activePatient?.user?.picture} alt={activePatient?.user?.name} />
                  <div className="info">
                    <div className="title">{`${activePatient?.user?.name || ''} ${activePatient?.user?.lastname || ''}`}</div>
                    {/* <div className="phase">Fase actual 4</div> */}
                    <div className="tag">{P.dataTranslation(activePatient?.process?.processName, language) || `Programa ${processId}`}</div>
                  </div>
                </div>

                <div className="divider" />

                <div className="patient-card__info">
                  <div className="contact-info">
                    <div className="contact-row">
                      <span>Teléfono del paciente</span>
                      <span>+{activePatient?.user?.phoneCountry.phonecode} {activePatient?.user?.phone}</span>
                    </div>
                    <div className="contact-row">
                      <span>Teléfono del cuidador</span>
                      <span>+{activePatient?.user?.carerPhoneCountry.phonecode} {activePatient?.user?.phoneCarer}</span>
                    </div>
                  </div>

                  <div className="risk">Riesgo de navegación BAJO</div>

                  <div className="points-section">
                    <div className="points">Puntos 1.2/10</div>
                    <button className="learn-more">Aprende más</button>
                  </div>

                  <div className="description">
                    <strong>Barreras Leves (Nivel 1):</strong> El paciente solo presenta barreras evaluadas con severidad 1 (como "Baja alfabetización en salud"), las cuales son manejables y el paciente puede resolverlas solo con información.
                    <br />
                    <br />
                    <strong>Impacto ponderado:</strong> Las barreras identificadas pertenecen a dominios con factor multiplicador bajo (ej. Comunicación con factor x1.0), manteniendo el 80% principal de la fórmula en el rango mínimo.
                    <br />
                    <br />
                    <strong>Ajuste por volumen:</strong> Solo se detectaron 2 barreras en total (rango de 0-3), lo que suma un ajuste de agudeza casi nulo en el 20% restante del cálculo.
                  </div>
                </div>
                
              </div>

              <div className="journey-card">
                <div className="journey-header">
                  <i className="icon zaia-i-location" style={{marginRight: '8px'}}></i>
                  <span>Ver journey del paciente</span>
                  <i className="icon zaia-i-arrow-2 icon-arrow"></i>
                </div>
                <div className="journey-desc">Es la ruta clínica del tratamiento del paciente</div>
              </div>
            </S.LeftPanel>

            {selectedBarrier ? (
              <BarrierDetails 
                barrier={selectedBarrier} 
                onBack={() => setSelectedBarrier(null)} 
              />
            ) : (
              <S.RightPanel>
                <div className="filters-row">
                <div className="select-box">
                  <FlorenzSelect
                    placeholder={"Todos"}
                    label={"Tipo de barrera"}
                    xsSize={true}
                    forWhiteBackgroud={false}
                    items={
                      barrierTypes?.typeBarrier?.map((item) => ({
                        value: item.id,
                        text: P.dataTranslation(item.name, language)
                      })) || []
                    }
                    value={selectedBarrierType}
                    setValue={setSelectedBarrierType}
                  /> 
                </div>
                <div className="select-box">
                  {/* <FlorenzSelect
                    placeholder={"4"}
                    label={"Fase"}
                    xsSize={true}
                    forWhiteBackgroud={false}
                    // items={
                    //   processTypes?.process?.map((item) => ({
                    //     value: item.id,
                    //     text: P.dataTranslation(item.processName, language),
                    //     img: item.img
                    //   })) || []
                    // }
                    // value={filterProgram}
                  /> */}
                </div>
                <div className="search-box">
                  <FlorenzSearchInput
                    placeholder={t("globally.search")}
                    forWhiteBackgroud={false}
                    getText={(text) => setInputText(text)}
                    borderanimation={false}
                  />
                </div>
              </div>

              <div className="barriers-list" onScroll={handleScroll}>
                {barriersList.map(barrier => (
                  <div 
                    className="barrier-item" 
                    key={barrier.id}
                    onClick={() => setSelectedBarrier(barrier)}
                    style={
                      {
                        cursor: 'pointer',
                        backgroundColor: false ? '#F7F7F8' : '#fff'
                      }
                    }
                  >
                    <div className="check-icon">
                      {
                        barrier.barrierStatus === "completed" 
                          ? <i className="icon-check icon zaia-i-check-1"></i>
                          : <i className="icon zaia-icono-check">⊘</i>
                      }
                    </div>
                    <div className="barrier-info">
                      <h4>{P.dataTranslation(barrier.subTypeBarrier?.typeBarrier?.name, language)}, {P.dataTranslation(barrier.subTypeBarrier?.name, language)}</h4>
                      <p>{barrier.description}</p>
                      <div className="meta">
                        <div className="meta-item">
                          <i className="meta-item-icon-calendar zaia-i-calendar-2"></i>
                          <span>{P.dataTranslation(barrier.barrierStatusValue?.name, language)}</span>
                        </div>
                        {/* <div className="meta-item">
                          <i className="meta-item-icon-location zaia-i-location"></i>
                          <span>Fase <strong>{barrier.phase}</strong></span>
                        </div> */}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </S.RightPanel>
            )}
          </div>
          {
            !selectedBarrier &&
            <div className="body-bottom">
              <S.Footer>
                <div 
                  className={`toggle-resolved ${showResolved ? 'active' : ''}`}
                  onClick={() => setShowResolved(!showResolved)}
                >
                  Ver barreras resueltas
                  <div className="toggle-switch" />
                </div>
                <FlorenzButton
                  typeStyle={"primary"}
                  size="s"
                  text={"Registrar barrera"}
                  onClick={() => onOpenNewBarrier && onOpenNewBarrier(activePatient?.id)}
                />
              </S.Footer>
            </div>
          }
        </S.Body>
      </div>
    </S.PatientBarriersModal>
  );
};

export default PatientBarriersModal;
